import { useEffect, useRef } from 'react';

function usePrevious<Data>(value: Data) {
  const ref = useRef<Data>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}

export default usePrevious;
